import { Component } from '@angular/core';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridReportSharedComponent } from '@unity/shared/grid-report-shared/grid-report-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-report-page',
  standalone: true,
  imports: [PageContainerComponent, GridReportSharedComponent, ActionSharedComponent],
  templateUrl: './list-report-page.component.html',
  styleUrl: './list-report-page.component.scss',
})
export class ListReportPageComponent {
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
